"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import Logo from "./Logo";
import { FaChevronDown, FaBars, FaTimes } from "react-icons/fa";
import Image from "next/image";
import MobileMenuPortal from "./MobileMenuPortal";

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [companyOpen, setCompanyOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);


  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    // Scroll event listener'ı ekle
    window.addEventListener("scroll", handleScroll);
    
    // İlk yükleme için state'i ayarla
    handleScroll();

    // Cleanup function
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full transition-all duration-300 ${
        isScrolled
          ? "bg-black bg-opacity-75 backdrop-blur-md"
          : "bg-black bg-opacity-100"
      } z-50`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link href="/" aria-label="FynWise">
              <Logo />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex flex-grow items-center justify-between">
            <nav className="flex items-center mx-auto">
              <ul className="flex space-x-8">
                {/* Company Dropdown */}
                <li className="relative group">
                  <button
                    className="text-gray-400 hover:text-white cursor-pointer flex items-center focus:outline-none font-inter"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Company <FaChevronDown size={16} className="ml-1" />
                  </button>
                  <div className="absolute left-0 top-full invisible group-hover:visible">
                    <div className="h-4"></div>
                    <div className="bg-[#000000]/90 backdrop-blur-sm rounded-lg shadow-2xl border border-white/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="flex gap-8 p-6 items-center">
                        {/* Left Column - Normal Links */}
                        <div className="flex flex-col space-y-4">
                          <Link
                            href="/company/blog"
                            className="text-gray-400 hover:text-white whitespace-nowrap transition-colors"
                          >
                            Blog
                          </Link>
                          <Link
                            href="/company/contact"
                            className="text-gray-400 hover:text-white whitespace-nowrap transition-colors"
                          >
                            Contact
                          </Link>
                          <Link
                            href="/company/faq"
                            className="text-gray-400 hover:text-white whitespace-nowrap transition-colors"
                          >
                            FAQ
                          </Link>
                        </div>

                        {/* Right Column - Featured Links */}
                        <div className="flex flex-col space-y-4 min-w-[280px]">
                          <Link
                            href="/company/about"
                            className="p-4 rounded-lg bg-black/50 border border-white/5 hover:bg-white/5 transition-colors shadow-lg relative overflow-hidden group"
                          >
                            <div className="absolute inset-0 to-transparent"></div>
                            <div className="flex items-center space-x-4 relative z-10">
                            <Image
                            src="/images/about.png"
                            alt="About Icon"
                            width={56}  // w-14 Tailwind sınıfı 56px'e denk gelir
                            height={48} // h-12 Tailwind sınıfı 48px'e denk gelir
                            className="w-14 h-12"
                             />
                              <div>
                                <div className="text-gray-400 group-hover:text-white whitespace-nowrap transition-colors">
                                  About Us
                                </div>
                                <div className="text-sm text-gray-400">
                                  Learn more us
                                </div>
                              </div>
                            </div>
                          </Link>
                          <Link
                            href="/company/careers"
                            className="p-4 rounded-lg bg-black/50 border border-white/5 hover:bg-white/5 transition-colors shadow-lg relative overflow-hidden group"
                          >
                            <div className="absolute inset-0 to-transparent"></div>
                            <div className="flex items-center space-x-4 relative z-10">
                              <Image
                                src="/images/careers.png"
                                alt="Careers Icon"
                                width={56}  // w-14 Tailwind sınıfı 56px'e denk gelir
                                height={48} // h-12 Tailwind sınıfı 48px'e denk gelir
                                className="w-14 h-12"
                              />
                              <div>
                                <div className="text-gray-400 group-hover:text-white whitespace-nowrap transition-colors">
                                  Careers
                                </div>
                                <div className="text-sm text-gray-400">
                                  Join our team
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                {/* Academy */}
                <li>
                  <Link
                    href="/academy"
                    className="text-gray-400 hover:text-white font-inter"
                  >
                    Academy
                  </Link>
                </li>

                {/* Services Dropdown */}
                <li className="relative group">
                  <button
                    className="text-gray-400 hover:text-white cursor-pointer flex items-center focus:outline-none font-inter"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Services <FaChevronDown size={16} className="ml-1" />
                  </button>
                  <div className="absolute left-0 top-full invisible group-hover:visible">
                    <div className="h-4"></div>
                    <div className="bg-[#000000]/90 backdrop-blur-sm rounded-lg shadow-2xl border border-white/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="flex gap-8 p-6 items-center">
                        {/* Left Column - Normal Links */}
                        <div className="flex flex-col space-y-4">
                          <Link
                            href="/services/backtesting"
                            className="text-gray-400 hover:text-white whitespace-nowrap transition-colors"
                          >
                        Advanced Backtesting
                        </Link>
                          <Link
                            href="/services/portfolio-optimization"
                            className="text-gray-400 hover:text-white whitespace-nowrap transition-colors"
                          >
                            Portfolio Optimization
                          </Link>
                          <Link
                            href="/services/live-signals"
                            className="text-gray-400 hover:text-white whitespace-nowrap transition-colors"
                          >
                            Live Signals
                          </Link>
                          <Link
                            href="/services/algorithmic-bots"
                            className="text-gray-400 hover:text-white whitespace-nowrap transition-colors"
                          >
                            Algorithmic Bots
                          </Link>
                        </div>

                        {/* Right Column - Featured Links */}
                        <div className="flex flex-col space-y-4 min-w-[280px]">
                          <Link
                            href="/services/fynbot"
                            className="p-4 rounded-lg bg-black/50 border border-white/5 hover:bg-white/5 transition-colors shadow-lg relative overflow-hidden group"
                          >
                            <div className="absolute inset-0 to-transparent"></div>
                            <div className="flex items-center space-x-4 relative z-10">
                              <Image
                                src="/images/chat.png"
                                alt="Chat Icon"
                                width={56}  // w-14 Tailwind sınıfı 56px'e denk gelir
                                height={48} // h-12 Tailwind sınıfı 48px'e denk gelir
                                className="w-14 h-12"
                              />
                              <div>
                                <div className="text-gray-400 group-hover:text-white whitespace-nowrap transition-colors">
                                FynBot
                                </div>
                                <div className="text-sm text-gray-400">
                                  Engage with AI assistant
                                </div>
                              </div>
                            </div>
                          </Link>
                          <Link
                            href="/services/simulation"
                            className="p-4 rounded-lg bg-black/50 border border-white/5 hover:bg-white/5 transition-colors shadow-lg relative overflow-hidden group"
                          >
                            <div className="absolute inset-0 to-transparent"></div>
                            <div className="flex items-center space-x-4 relative z-10">
                              <Image
                                src="/images/simulation.png"
                                alt="Simulation Icon"
                                width={56}  // w-14 Tailwind sınıfı 56px'e denk gelir
                                height={48} // h-12 Tailwind sınıfı 48px'e denk gelir
                                className="w-14 h-12"
                              />
                              <div>
                                <div className="text-gray-400 group-hover:text-white whitespace-nowrap transition-colors">
                                  Dynamic Simulation
                                </div>
                                <div className="text-sm text-gray-400 whitespace-nowrap">
                                  Test strategies in real-time
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                {/* Pricing */}
                <li>
                  <Link
                    href="/pricing"
                    className="text-gray-400 hover:text-white font-inter"
                  >
                    Pricing
                  </Link>
                </li>
              </ul>
            </nav>

            {/* Right Menu Items */}
            <div className="flex items-center space-x-6">
              <Link
                href="/auth/signin"
                className="text-gray-400 hover:text-white font-inter whitespace-nowrap transition-colors text-left"
              >
                Sign In
              </Link>
              <Link href="/auth/signup">
                <button className="font-inter w-[120px] bg-white h-[40px] my-3 flex items-center justify-center rounded-xl cursor-pointer relative overflow-hidden transition-all duration-500 ease-in-out shadow-md hover:scale-105 hover:shadow-lg before:absolute before:top-0 before:-left-full before:w-full before:h-full before:bg-black before:transition-all before:duration-500 before:ease-in-out before:z-[-1] before:rounded-xl hover:before:left-0 text-black hover:text-white">
                  Join Waitlist
                </button>
              </Link>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button onClick={toggleMobileMenu} className="text-gray-400 hover:text-white font-inter focus:outline-none">
              {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu - Sidebar Style */}
        {/* Mobile Menu Portal kullanarak menüyü render et */}
        <MobileMenuPortal isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)}>
          <ul className="space-y-4 py-4">
            {/* Company Dropdown Mobile */}
            <li>
              <button
                onClick={() => setCompanyOpen(!companyOpen)}
                className="w-full text-left text-gray-400 px-4 py-2 flex justify-between items-center focus:outline-none"
              >
                Company{" "}
                <FaChevronDown
                  className={`transition-transform ${
                    companyOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              {companyOpen && (
                <ul className="pl-4 space-y-2">
                  <li>
                    <Link
                      href="/company/about"
                      className="block px-4 py-2 text-gray-400 hover:text-white"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      About
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/company/careers"
                      className="block px-4 py-2 text-gray-400 hover:text-white"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Careers
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/company/blog"
                      className="block px-4 py-2 text-gray-400 hover:text-white"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Blog
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/company/contact"
                      className="block px-4 py-2 text-gray-400 hover:text-white"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/company/faq"
                      className="block px-4 py-2 text-gray-400 hover:text-white"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      FAQ
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Academy */}
            <li>
              <Link
                href="/academy"
                className="block px-4 py-2 text-gray-400 hover:text-white"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Academy
              </Link>
            </li>

            {/* Services Dropdown Mobile */}
            <li>
              <button
                onClick={() => setServicesOpen(!servicesOpen)}
                className="w-full text-left text-gray-400 px-4 py-2 flex justify-between items-center focus:outline-none"
              >
                Services{" "}
                <FaChevronDown
                  className={`transition-transform ${
                    servicesOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              {servicesOpen && (
                <ul className="pl-4 space-y-2">
                  <li>
                    <Link
                      href="/services/fynbot"
                      className="block px-4 py-2 text-gray-400 hover:text-white"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      FynBot
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/services/simulation"
                      className="block px-4 py-2 text-gray-400 hover:text-white"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Dynamic Simulation
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/services/backtesting"
                      className="block px-4 py-2 text-gray-400 hover:text-white"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Advanced Backtesting
                    </Link>
                  </li>
                  <li>
                  <Link
                      href="/services/portfolio-optimization"
                      className="block px-4 py-2 text-gray-400 hover:text-white"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Portfolio Optimization
                  </Link>
                  </li>
                  <li>
                    <Link
                      href="/services/live-signals"
                      className="block px-4 py-2 text-gray-400 hover:text-white"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Live Signals
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/services/algorithmic-bots"
                      className="block px-4 py-2 text-gray-400 hover:text-white"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Algorithmic Bots
                    </Link>
                    </li>
                </ul>
              )}
            </li>

            {/* Pricing */}
            <li>
              <Link
                href="/pricing"
                className="block px-4 py-2 text-gray-400 hover:text-white"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Pricing
              </Link>
            </li>

            {/* Sign In */}
            <li>
              <Link
                href="/auth/signin"
                className="block px-4 py-2 text-gray-400 hover:text-white"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Sign In
              </Link>
            </li>

            {/* Sign Up */}
            <li className="px-4 py-2">
              <Link href="/auth/signup" onClick={() => setIsMobileMenuOpen(false)}>
                <button className="w-full bg-white h-10 flex items-center justify-center rounded-xl text-black hover:scale-105">
                Join Waitlist
                </button>
              </Link>
            </li>
          </ul>
        </MobileMenuPortal>
      </div>
    </header>
  );
}